export default "__VITE_ASSET__05201107__"